module.exports = new __parcel__URL__("attack_log_tab.62705ee7.png").toString();